export default __webpack_public_path__ + "static/media/category-5.1cfa0727.svg";